import React from 'react';
import {geolocated} from 'react-geolocated';

class Geolocation extends React.Component {

    componentWillReceiveProps(nextProps, nextContext) {
        const {coords} = nextProps;
        if (coords) {
            this.props.update(coords);
        }
    }

    render() {
        return null;
    }

}

export default geolocated({
    positionOptions: {
        enableHighAccuracy: false,
    },
    suppressLocationOnMount: false,
    userDecisionTimeout: 0,
    geolocationProvider: navigator.geolocation
})(Geolocation);
